// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3df3o","title":"ClientInsurance_title__24Fgv","itemText":"ClientInsurance_itemText__1Ne1U"};